import React, { useRef, useContext, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { DynamicChartContext } from ".";
import { Spin } from "antd";

const options = {
  title: {
    text: "Number of Problematic Cases",
    margin: 50,
    style: { fontSize: "1.5rem", fontWeight: "bold" },
  },
  chart: {
    style: {
      fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
          "Helvetica Neue", Arial, "Noto Sans", sans-serif,
          "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
    },
  },
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  colors: ["#2F5EC4", "#45a5f5"],
  plotOptions: {
    line: {
      lineWidth: 2,
      states: {
        hover: {
          lineWidth: 3,
        },
      },
      marker: {
        enabled: false,
      },
    },
  },
  yAxis: {
    lineWidth: 1,
    title: {
      enabled: false,
    },
  },
  xAxis: {
    type: "category",
    labels: {
      style: { fontWeight: "bold" },
    },
    lineWidth: 1,
  },
  tooltip: {
    shared: true,
  },
  series: [],
};

const Result = () => {
  const { dataSource, loading } = useContext(DynamicChartContext);

  const chartResultRef = useRef(null);

  useEffect(() => {

    while (chartResultRef.current.chart.series.length) {
      chartResultRef.current.chart.series[0].remove();
    }

    if (dataSource && dataSource.length > 0 && !loading) {
      chartResultRef.current.chart.addSeries(
        {
          type: "line",
          name: "Problematic",
          data: (dataSource).map((d) => [
            d.PERIOD_START_TIME,
            Number(d.Count),
          ]),
          dataLabels: {
            enabled: true,
            formatter: function () {
              return this.y;
            },
          },
        },
        true
      );
    }
  }, [loading, dataSource]);

  return (
    <>
      <Spin spinning={loading}>
        <div>
          <HighchartsReact
            ref={chartResultRef}
            highcharts={Highcharts}
            options={options}
          />
        </div>
      </Spin>
    </>
  );
};

export default Result;
